export const FORM_VALIDATION_HTTP_STATUS: number = 422
export const HTTP_NOT_FOUND: number = 404
export const HTTP_ACCESS_FORBIDDEN: number = 403
export const HEADERS: {[key: string]: string} = {
  ACCEPT: 'Accept',
  ACCEPT_LANGUAGE: 'Accept-Language',
  CONTENT_TYPE: 'Content-Type',
}
